import { FilterModalDatePicker } from './FilterModal';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useId, useMemo } from 'react';
import { DateInput, validateDateTimeFields } from '../dateHelper';
import { Moment } from 'moment';
import { convertMomentToDate } from '../inputValidations';

interface DateRangeFilterProps<T> {
    timeframeFilterTitle: string;
    startDateFilterName: keyof T;
    endDateFilterName: keyof T;
    startDate: DateInput;
    endDate: DateInput;
    setLocalFilters: Dispatch<SetStateAction<T>>;
}

export const DateRangeFilter = <T,>({
    timeframeFilterTitle,
    startDateFilterName,
    endDateFilterName,
    startDate,
    endDate,
    setLocalFilters,
}: DateRangeFilterProps<T>) => {
    const startDateId = useId();
    const endDateId = useId();

    const { hasStartDateTimeError, hasEndDateTimeError, hasTimeRangeOrderError } = useMemo(
        () => validateDateTimeFields(startDate, endDate),
        [startDate, endDate],
    );

    return (
        <>
            <label className="margin-bottom-5">
                <FormattedMessage id={timeframeFilterTitle} />
            </label>
            <div className="display-flex justify-content-start row">
                <div className="col-6 padding-right-5">
                    <FilterModalDatePicker
                        id={startDateId}
                        labelId="outboundPortal.common.table.from"
                        hasFormatError={hasStartDateTimeError}
                        hasTimeRangeOrderError={false}
                        value={startDate}
                        onChange={(date: Moment | string | undefined) =>
                            setLocalFilters((prevState) => ({
                                ...prevState,
                                [startDateFilterName]: convertMomentToDate(date),
                            }))
                        }
                        isOptional
                    />
                </div>
                <div className="col-6 padding-left-5">
                    <FilterModalDatePicker
                        id={endDateId}
                        labelId="outboundOrderBook.common.dateRange.to"
                        hasFormatError={hasEndDateTimeError}
                        hasTimeRangeOrderError={hasTimeRangeOrderError}
                        value={endDate}
                        onChange={(date: Moment | string | undefined) =>
                            setLocalFilters((prevState) => ({
                                ...prevState,
                                [endDateFilterName]: convertMomentToDate(date),
                            }))
                        }
                        isOptional
                    />
                </div>
            </div>
        </>
    );
};
